/**
 * 用户面板
 * @author lianghua.fu
 * @date 2022-03-21 23:01:12
 */
import { useStateful, useArray, useBoolean } from 'react-hanger';
import { request, hoc, hooks, base, user } from 'lib';
import { UiToast } from 'components';
import get from 'lodash/get';

import { useEffect, useLayoutEffect, useRef } from 'react';
import { getGlobalStore } from 'stores';
import messages from 'widgets/functions/messages/service';
import { store as giftBottom } from 'modules/widgets/functions/gift/store/gift-bottom';
import socket from 'modules/widgets/lib/socket';
import { IdenNum, NickName } from '../iden';
import { IdenCommon } from '../iden/msg-iden';
import {
  MenuShutUp,
  MenuKickOut,
  MenuAdmin,
  MenuHonourFans,
  PartyMute,
  PartyKick,
  PartyBlack,
} from './menus';
import roomLib from '../../lib/room';
import styled from './styled';

const { Wrap, StyledMenu, StyledStarInfo } = styled;

const Index = (props) => {
  const {
    isOpenMystic,
    userId,
    onClose = () => {},
    showMenu = true,
    mouseX,
    mouseY,
    newUser,
  } = props;
  const userData = useStateful(null);
  const extraData = useStateful({});
  const style = useStateful({});
  const ref = useRef();
  const roomId = roomLib.getRoomId();
  const isSubMenuLeft = useBoolean(false);
  const isSelf = user.isSelf(userId);

  const loadUserInfo = () => {
    Promise.all([
      request.api.get(`zone/user_info/${userId}`, {
        room_id: roomId,
      }),
      // 装扮信息，真爱团信息，贵族，守护
      // http://mock.memeyule.com/project/16/interface/api/4522
      // request.cryolite.get(`api/v1/data/card/user`, {
      //   userId,
      //   anchorId: roomId,
      // }),
    ])
      .then(([baseRes, extraRes]) => {
        const { mystic, ...rest } = baseRes.data;
        // FIX: 是否开启神秘人信息,按照打开弹窗前状态确定
        userData.setValue({
          ...rest,
          mystic: {
            ...mystic,
            open: isOpenMystic || false,
          },
        });
      })
      .catch((res) => {
        UiToast.fail(res.msg || '数据获取失败');
        onClose();
      });
  };

  useEffect(() => {
    if (`${userId}` === `${roomId}`) {
      onClose();
    } else {
      loadUserInfo();
    }
  }, []);

  useLayoutEffect(() => {
    if (userData.value) {
      const { innerHeight, innerWidth } = window;
      const { clientWidth, clientHeight } = ref.current;
      const value = {
        left: mouseX + 10,
        top: mouseY,
      };

      if (innerWidth - mouseX < clientWidth) {
        value.left = mouseX - clientWidth - 10;
      } else if (innerWidth - mouseX - clientWidth < 122) {
        isSubMenuLeft.setTrue();
      }
      if (innerHeight - mouseY < clientHeight) {
        value.top = innerHeight - clientHeight;
      }
      // console.log('userPanel', {
      //   mouseX,
      //   mouseY,
      //   innerHeight,
      //   innerWidth,
      //   clientWidth,
      //   clientHeight,
      //   value,
      // });
      style.setValue(value);
    }
  }, [userData.value]);

  hooks.useClickAway(ref, () => {
    onClose();
  });

  // const user = {
  //   spend: 1201212,
  //   group_info: {
  //     group_level: 4,
  //     group_name: '真爱团',
  //     guard_type: 3,
  //   },
  // };

  if (!userData.value) {
    return null;
  }
  // sex  ['女','男']
  const {
    _id,
    pic,
    nick_name,
    position,
    location = '-',
    family,
    mm_no,
    sex,
    mystic,
    is_24_hr_new_user,
    honor_fans,
  } = userData.value;

  const hasMemeNo = _id !== mm_no;

  const isParty = roomLib.isPartyRoom();

  const isEnableManage = () => {
    const partyPrivilege = roomLib.isHost();

    return isParty ? partyPrivilege : true;
  };

  const renderNickname = () => {
    let nick = nick_name;
    if (isOpenMystic) {
      nick = mystic?.nick_name || nick_name;
    }
    return nick;
  };

  const renderPic = () => {
    if (isOpenMystic) {
      return mystic?.pic || pic;
    }
    return pic;
  };

  const handleViewHome = () => {
    if (!isOpenMystic) {
      base.redirectUrl(`/u/${mm_no}`, true);
    }
  };
  const handleSendGift = () => {
    giftBottom.addUser({
      uid: _id,
      name: nick_name,
    });
    socket.emitMsg('user_panel$send_gift');
  };
  const handleChatAt = () => {
    messages.chatAt(userData.value);
  };
  const handleChatIm = () => {
    if (window.ImApp) {
      ImApp.addChat(_id);
    } else {
      UiToast.fail('私聊模块未初始化');
    }
  };

  const handleMouseLeave = () => {
    // onClose()
  };

  const handleMenuClick = () => {
    onClose();
  };

  return (
    <Wrap ref={ref} onMouseLeave={handleMouseLeave} style={style.value}>
      <StyledStarInfo>
        <div className="avatar" onClick={handleViewHome}>
          <img src={renderPic()} alt="" />
        </div>
        {isOpenMystic ? (
          <div className="info">
            <div className="row">
              <span className="nickname text-overflow" onClick={handleViewHome}>
                {renderNickname()}
              </span>
            </div>
          </div>
        ) : (
          <div className="info">
            <div className="row">
              <span className="nickname text-overflow" onClick={handleViewHome}>
                {renderNickname()}
              </span>
              {hasMemeNo ? (
                <IdenNum mmNo={mm_no} userId={_id}></IdenNum>
              ) : (
                <span className="user-num">(ID:{_id})</span>
              )}
            </div>
            <div>
              <IdenCommon type="userMenu" user={userData.value}></IdenCommon>
              {/* <CoinLevel user={user}></CoinLevel> <Guard user={user}></Guard> */}
            </div>
            <div className="desc">
              地址: {location}
              {family ? ` | 家族：${family.family_name}` : ''}
            </div>
          </div>
        )}
      </StyledStarInfo>

      {showMenu && !isSelf && (
        <StyledMenu className={isSubMenuLeft.value ? '_subMenuLeft' : ''} onClick={handleMenuClick}>
          {!isOpenMystic && (
            <>
              <li onClick={handleViewHome}>查看TA的主页</li>
              <li onClick={handleSendGift}>向TA赠送礼物</li>
              <li onClick={handleChatAt}>@TA</li>
              <li onClick={handleChatIm}>私聊TA</li>
            </>
          )}
          {isEnableManage() &&
            (isParty ? (
              <>
                <PartyMute userId={_id} roomId={roomId} />
                <PartyBlack userId={_id} roomId={roomId} />
                <PartyKick userId={_id} roomId={roomId} />
              </>
            ) : (
              <>
                <MenuShutUp userId={_id} roomId={roomId}></MenuShutUp>
                <MenuKickOut userId={_id} roomId={roomId}></MenuKickOut>
                {!isOpenMystic && (
                  <>
                    <MenuAdmin userId={_id} roomId={roomId}></MenuAdmin>
                    <MenuHonourFans userId={_id} honorFans={honor_fans}></MenuHonourFans>
                  </>
                )}
              </>
            ))}
        </StyledMenu>
      )}
    </Wrap>
  );
};

Index.show = (userId, opt = {}) => {
  const { clientX, clientY } = getGlobalStore().position.position;

  hoc.render(
    {
      mouseX: clientX,
      mouseY: clientY,
      userId,
      ...opt,
    },
    Index,
  );
};

export default Index;
